import { copy } from "./shared";
import CheckoutForm from "./CheckoutForm";
import "../templates/Template6.css";
import "./CheckoutTemplate6.css";

/*
   Checkout Template 6 — a seamless continuation of sales Template 6 ("Aurora
   Glass"). Reuses Template6.css directly (same .clp6-root design system): the
   drifting aurora background, the sticky glass .g6-nav, the .g6-hero band with
   its gradient .g6-title, the .g6-btn/.g6-btn-p button and the .g6-foot footer.
   Only the form + order-summary cards are checkout-specific
   (CheckoutTemplate6.css), styled as frosted glass cards to match the template.
*/
export default function CheckoutTemplate6({ data = {}, code }) {
  const c = copy(data);

  return (
    <div className="clp6-root">
      {/* Animated aurora background — same as the sales page */}
      <div className="g6-aurora" aria-hidden="true">
        <span className="b b1" />
        <span className="b b2" />
        <span className="b b3" />
      </div>

      {/* NAV — same frosted glass nav as the sales page */}
      <nav className="g6-nav scr">
        <div className="g6-wrap g6-nav-in">
          <span className="g6-logo">
            {c.logo ? <img src={c.logo} alt="" /> : <span className="cok6-brandtext">{c.brand}</span>}
          </span>
          <span className="cok6-secure">🔒 Secure checkout</span>
        </div>
      </nav>

      {/* HERO — reuses the sales hero band + gradient title */}
      <header className="g6-hero cok6-hero">
        <div className="g6-wrap">
          <div className="cok6-hero-content">
            <span className="cok6-eyebrow">Checkout</span>
            <h1 className="g6-title cok6-title">
              Complete your <span className="cok6-accent">enrollment</span>
            </h1>
            {c.sub ? <p className="g6-sub cok6-sub">{c.sub}</p> : null}
          </div>
        </div>
      </header>

      {/* FORM + ORDER SUMMARY — in the template's frosted-glass card style */}
      <div className="g6-wrap">
        <CheckoutForm data={data} code={code} p="cok6" c={c} />
      </div>

      {/* FOOTER — same as the sales page */}
      <footer className="g6-foot">
        <div className="g6-wrap">
          <div className="cok6-foot">{c.guaranteeOn ? c.guarantee : `© ${c.brand}`}</div>
        </div>
      </footer>
    </div>
  );
}
